/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__options__currency__nok = /** @type {(inputs: {}) => string} */ () => {
	return `kr - Norwegische Krone`
};

const en_itinerary__options__currency__nok = /** @type {(inputs: {}) => string} */ () => {
	return `kr - Norwegian Krone`
};

const es_itinerary__options__currency__nok = /** @type {(inputs: {}) => string} */ () => {
	return `kr - Corona noruega`
};

const fr_itinerary__options__currency__nok = /** @type {(inputs: {}) => string} */ () => {
	return `kr - Couronne norvégienne`
};

const it_itinerary__options__currency__nok = /** @type {(inputs: {}) => string} */ () => {
	return `kr - Corona norvegese`
};

const nl_itinerary__options__currency__nok = /** @type {(inputs: {}) => string} */ () => {
	return `kr - Noorse kroon`
};

const pt_itinerary__options__currency__nok = /** @type {(inputs: {}) => string} */ () => {
	return `kr - Coroa norueguesa`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__nok = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__options__currency__nok(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__options__currency__nok", locale)
	if (locale === "de") return de_itinerary__options__currency__nok(inputs)
	if (locale === "en") return en_itinerary__options__currency__nok(inputs)
	if (locale === "es") return es_itinerary__options__currency__nok(inputs)
	if (locale === "fr") return fr_itinerary__options__currency__nok(inputs)
	if (locale === "it") return it_itinerary__options__currency__nok(inputs)
	if (locale === "nl") return nl_itinerary__options__currency__nok(inputs)
	return pt_itinerary__options__currency__nok(inputs)
};